<template>
  <div>
    <a-select
      :disabled="disabled"
      :multiple="false"
      :placeholder="placeholder"
      :value="value"
      :class="class"
      allow-clear
      option-filter-prop="title"
      show-search
      @change="onChange"
    >
      <a-select-option
        v-for="item in records"
        :key="item?.putRequestId"
        :title="item?.putRequestNo"
        :value="item?.putRequestId"
      >
        {{ item?.putRequestNo }}
      </a-select-option>
    </a-select>
  </div>
</template>

<script lang="ts">
import _ from "lodash";
import { defineComponent, onActivated, onMounted, watch } from "vue";
import { PurchaseAndMaterialReturnService } from "./service";
import { useRoute } from "vue-router";
/**
 * 合同选择器
 *
 * 使用方式:
 * <contract-select v-model:value="formRef.contractId"></contract-select>
 */
export default defineComponent({
  isGlobal: true,
  name: "PurchaseAndMaterialReturn",
  props: {
    externalData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    value: {
      type: String,
      default: undefined,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    placeholder: {
      type: String,
      default: "请选择",
    },

    projectId: {
      type: String,
      default: undefined,
    },
    distinguish: {
      type: String,
      default: undefined,
    },
    //
    paymentContract: {
      type: String,
      default: undefined,
    },

    contractStatus: {
      type: Array,
      default: () => [],
    },
    class: {
      type: String,
      default: "append-to-body",
    },
    type: {
      type: String,
      default: "",
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:value", "change", "changetype"],
  setup(props, { emit }) {
    // const { data: records, run, loading } = PurchaseAndMaterialReturnService.useSimpleListApi();
    const { data: records, run, loading } = PurchaseAndMaterialReturnService.getPutStorageDetail();
    const route = useRoute();
    const onChange = async (id, option?) => {
      //@ts-ignore

      let current = records.value.find((o) => o["putRequestId"] == id);
      // console.log(id, "~~~~~~~", current);

      emit("update:value", id);
      emit("change", current);
      emit("changetype", current);
    };

    const search = async () => {
      // const req = { projectId: props.projectId, type: props.type == "采购入库" ? "cgrk" : "tlrk" };
      const req = {
        firstDisplayProjectId:route['query']['projectId']?route['query']['projectId']:null,
      };
      await run(req);
      if (props.value && !props.isEdit) {
        onChange(props.value);
      }
    };
    onMounted(async () => {
      await search();
    });
    onActivated(async () => {
      await search();
    });
    // watch(
    //   () => props.externalData?.contractId,
    //   async () => {
    //     // console.log(props.distinguish, "props.distinguish>>>>>>>");
    //     await search();
    //   },
    //   { immediate: true }
    // );

    // 修改项目时, 重新获取项目下的合同
    // watch(
    //   () => props.value,
    //   async (newValue) => {
    //     if (newValue) {
    //       await search();
    //     }
    //   },
    //   { immediate: true }
    // );
    // watch(
    //   () => props.type,
    //   async (newValue) => {
    //     if (newValue) {
    //       await search();
    //     } else {
    //       records.value = { records: [] };
    //     }
    //   },
    //   { immediate: true }
    // );
    // watch(
    //   () => props.projectId,
    //   async (newValue) => {
    //     if (newValue) {
    //       await search();
    //     } else {
    //       records.value = { records: [] };
    //     }
    //   },
    //   { immediate: true }
    // );
    return {
      records,
      loading,
      onChange,
    };
  },
});
</script>
